// export const ID_62_LENGTH = 22;
export const SHORTENED_RENDERED_ID_LENGTH = 8;

export function getShortenedId(id: string | undefined, length = SHORTENED_RENDERED_ID_LENGTH): string | undefined {
  const end = length < 0 ? undefined : length;
  const base = end ? id?.slice(0, end) : id?.slice(length);

  const lengthAbs = Math.abs(length);

  if (base?.length === lengthAbs && (id?.length || 0) > lengthAbs) {
    if (length < 0) {
      return `…${base}`;
    }

    return `${base}…`;
  }

  return base;
}
